import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import BACKEND_URL from "../../api";
import loading from '../../images/spin.gif'

const Verify = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState("");

    const getQueryParams = (search) => {
        const params = new URLSearchParams(search);
        return params.get('code'); // Get the 'code' parameter
    };

    useEffect(() => {
        const code = getQueryParams(location.search); // Extract the code from the URL
        if (code) {
            verifyEmail(code); // Call the verification function with the code
        }
    }, [location]);

    const verifyEmail = async (code) => {
        try {
            const response = await axios.post(`${BACKEND_URL}/verifyEmail`, { code: code });
            console.log("verifyEmail----------:", response.data);
            if (response.data.code === 0) {
                setErrorMessage(response.data.msg);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error("Error verifying email:", error);
            // Optionally, you could set an error message in state here
            setErrorMessage("An error occurred while verifying the email. Please try again.");
        }
    };

    return (
        <div>
            {
                errorMessage == "" ?
                    <p style={{ textAlign: "center", padding: "10px" }}><img src={loading} style={{ width: "5%" }} /></p>
                    : <p style={{
                        textAlign: "center",
                        marginTop: "2%",
                        color: "#f44336", // Red background for error
                        padding: "10px",
                        fontSize: "1.5em",
                        fontWeight: "bold"
                    }}>
                        {errorMessage}
                    </p>
            }
        </div>
    );
}

export default Verify;